"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorMtaExcessChangeBanner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var portal_core_1 = require("@ferry/portal-core");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualMotorMtaExcessChangeBanner = /** @class */ (function (_super) {
    __extends(AnnualMotorMtaExcessChangeBanner, _super);
    function AnnualMotorMtaExcessChangeBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnnualMotorMtaExcessChangeBanner.prototype.render = function () {
        var compulsoryExcess = this.props.interaction.vehicles[0].annualVehicleExcess.compulsoryExcess;
        var voluntaryExcess = this.props.interaction.vehicles[0].annualVehicleExcess.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        return ((0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold", children: "Heads up" }), " - as a result of this change your compulsory excess may change. Your total excess will be ", (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountWithoutDecimalDigits)(totalExcess) })] }) }));
    };
    return AnnualMotorMtaExcessChangeBanner;
}(React.Component));
exports.AnnualMotorMtaExcessChangeBanner = AnnualMotorMtaExcessChangeBanner;
//# sourceMappingURL=AnnualMotorMtaExcessChangeBanner.js.map